<template>
    <v-container fluid v-if="!$store.getters.progress" class="container-production py-0">
        <v-row class="fill-height ma-0">
            <v-col class="fill-height pa-0" cols="12" >
                <v-card class="flex fill-height pa-0">
                    <v-toolbar flat color="background-1" class="main-toolbar" tabs>
                        <v-toolbar-items >
                            <v-btn to="/production" exact active-class="primary--text" text @click.stop="">Produzione</v-btn>
                            <template v-if="isManager">
                                <v-btn to="/production/manager" exact active-class="primary--text" text @click.stop="">Manager</v-btn>
                            </template>
                        </v-toolbar-items>
                        <v-spacer></v-spacer>
                        <v-autocomplete
				            label="Cerca un prodotto nelle teste"
                            :items="loomProductSaleorderItems"
                            :loading="isLoading"
                            :search-input.sync="searchInHeads"
                            hide-details
				            prepend-icon="search"
				            clearable
                            outlined
                            return-object
                            item-text='product_name'
                            item-value='loom_productsaleorder_id'
                            dense>
                            <template
                                v-slot:item="data">
                                <template>
                                    <v-list-item-content @click="setLoom(data.item)">
                                        <v-list-item-title>{{ data.item.zone }} - {{ data.item.name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ data.item.product_name }} <template v-if="data.item.color"> - <span v-for="(color, c) in data.item.color" :key=c> {{color}}</span></template></v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-container class="pa-0 px-0" fluid>

                        <v-navigation-drawer 
                            class="navigation-drawer-looms"
                            hide-overlay
                            v-model="drawer"
                            absolute
                            stateless
                            permanent
                            touchless
                            width="200">
                            <v-list class="pt-0 zones-list">
                                <v-list-group v-for="(zone, z) in zones"
                                    prepend-icon="place"
                                    :value="currentLoom.zone === z ? true : false"
                                    :key="z">
                                    <template v-slot:activator>
                                        <v-list-item>
                                            <v-list-item-title>{{ z }}</v-list-item-title>
                                        </v-list-item>
                                    </template>

                                    <v-list-item v-for="(loom, l) in zone" 
                                        ripple
                                        dense
                                        :key="l"
                                        @click="setLoom(loom)">
                                        <v-list-item-title :class="currentLoom.id === loom.id ? 'amber--text' : ''">{{ loom.name }}</v-list-item-title>
                                        <v-list-item-action>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </v-navigation-drawer>
                        <div class="heads-container" :style="{right: !isProduction ? '200px' : '0px'}">
                            <v-slide-x-reverse-transition style="display: flex" group>
                                <v-card class="my-3 mx-2 head background-1" v-for="n in headNumber" :key="n">
                                    <v-toolbar color="primary" text height="56px;" class="head-header">
                                        <v-toolbar-title class="pl-3 ">Testa {{ n }}</v-toolbar-title>
                                    </v-toolbar>
                                    <v-divider></v-divider>
                                    <v-list class="head-item product-in-process" :id="n">
                                        <draggable
                                            :list="products_in_process[n]"
                                            :options="{
                                                group:'loom_product',
                                                animation: 350,
                                                ghostClass: 'ghost',
                                                chosenClass: 'chosen',
                                                disabled: isProduction
                                            }"
                                            @start="drag = true"
                                            @end="onDrag($event, 'loom_product')"
                                            style="min-height: 100px" class="background-1">
                                            <div v-for="(product, p) in products_in_process[n]" :id="product.id" :key="`${p}-${product.id}`" class="product-in-process-item cursor-pointer">
                                                <div class="pa-2 fs12 cursor-pointer">
                                                    <div class="fw500" style="display: flex; margin: auto;">
                                                        <div style="margin: auto; margin-left: 0;">
                                                            {{ product.name }}
                                                        </div>
                                                        <div v-if="product.saleorder_status == 'canceled'">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon v-on="on" size="18" color="error" class="style">fiber_manual_record</v-icon>
                                                                </template>
                                                                <span>Ordine Annullato</span>
                                                            </v-tooltip>                                                                
                                                        </div>                                                        
                                                    </div>
                                                    <div style="display: flex; margin: auto;">
                                                        <div>
                                                            Quantità: <span class="fw500">{{ Number.isInteger(product.processed_quantity) ? product.processed_quantity : product.processed_quantity.toFixed(1) }} / {{ Number.isInteger(product.quantity_to_process) ? product.quantity_to_process : product.quantity_to_process.toFixed(1) }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <v-chip v-for="(color, c) in product.color" :key="c" small>
                                                            {{ color }}
                                                        </v-chip>
                                                    </div>
                                                    <div class="list-card-footer-item" style="display: flex; align-items: center; margin: auto; margin-right: 0;">
                                                        <div :class="colorProductStatus(product.status)">{{ product.status_text }}</div>
                                                        <div style="display: flex; margin: auto; margin-right: 0;" class="small-icon">
                                                            <v-btn v-if="!isProduction" icon ripple @click="startDelete(product)" style="margin: 0; height: 32px; width: 32px">
                                                                <v-icon color="grey lighten-1">delete</v-icon>
                                                            </v-btn>
                                                            <v-btn icon ripple @click="openEditDialog(product)" style="margin: 0; height: 32px; width: 32px">
                                                                <v-icon color="grey lighten-1">edit</v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                                <v-divider></v-divider>
                                            </div>
                                        </draggable>
                                    </v-list>
                                </v-card>
                            </v-slide-x-reverse-transition>
                        </div>

                        <v-navigation-drawer
                            v-if="!isProduction"
                            style="height: calc(100% - 65px); border-left: 2px solid #f4f4f4; top: 65px"
                            hide-overlay
                            v-model="drawer"
                            right
                            absolute
                            stateless
                            permanent
                            touchless
                            width="200"
                            class="head">
                                <v-row class="head-header py-0 ma-0" style="max-height:100px; position: fixed;">
                                    <v-col cols="12" class="py-0 px-0">
                                        <v-text-field                                    
                                            append-icon="search"
                                            label="Cerca" 
                                            v-model="search"
                                            solo 
                                            flat 
                                            hide-details
                                            class="mb-0"
                                        ></v-text-field>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="12" class="py-0 px-0">
                                        <v-select
                                            v-model="productCategoriesSelected"
                                            class="ma-0"
                                            v-if="fieldsset.productcategories"
                                            :items="fieldsset.productcategories.options"
                                            label="Categoria"
                                            clearable
                                            dense
                                            solo
                                            flat
                                            small-chips
                                            hide-details
                                        ></v-select>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <div class="py-0 product-to-process">
                                    <div v-for="(product, p) in productsInProcess" :key="p" @click="openDialog(product)" class="product-to-process-item cursor-pointer">
                                        <div class="pa-2 fs12">
                                            <div class="fw500" style="display: flex; margin: auto;">
                                                <div style="margin: auto; margin-left: 0;">
                                                    {{ product.name }}
                                                </div>
                                                <div class="list-card-footer-item" style="display: flex; align-items: center; margin: auto; margin-right: 0;">
                                                    <v-avatar :class="$eventBusUtility.priorityColor(product.order_priority.charAt(0).toLowerCase())" :size="20" style="margin: auto; margin-right: 0;">
                                                        <span class="white--text fs12 capitalize">{{ product.order_priority.charAt(0) }}</span>
                                                    </v-avatar>
                                                </div>
                                            </div>
                                            <div style="display: flex; margin: auto;">
                                                <div>
                                                    Quantità: <span class="fw500">{{ product.quantity_to_process }}</span>
                                                </div>
                                                <div class="fw500" style="display: flex; align-items: center; margin: auto; margin-right: 0;">
                                                    N. {{ product.number }}
                                                </div>
                                            </div>
                                            <div>
                                                <v-chip v-for="(color, c) in product.color" :key="c" x-small>
                                                    {{ color }}
                                                </v-chip>
                                            </div>
                                            <div>{{ product.business_name }}</div>
                                        </div>
                                        <v-divider></v-divider>
                                    </div>
                                </div>

                        </v-navigation-drawer>
                    </v-container>
                </v-card>
            </v-col>
            <confirm-dialog
                :confirmModel="confirmDelete"
                mainTitle="Eliminare questo elemento?"
                secondTitle="Una volta eliminato non sarà possibile ripristinarlo"
                @update:confirmModel="confirmDelete = false"
                :atConfirm="deleteLoomProduct"
                :confirm="{label:'Procedi', color:'info'}"
            ></confirm-dialog>
        </v-row>

        <v-dialog
            v-model="dialog"
            width="800"
            ref="adddialog"
            >
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Aggiungi in produzione</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="pa-2" fluid>
                        <v-row class="ma-0">
                            <v-col cols="8" class="pa-0" style="display: flex;">
                                <v-subheader>Prodotto</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.name }}
                                    <v-btn icon @click="$eventBusUtility.goTo($router, 'products', model.product_id)">
                                        <v-icon>keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col cols="4" class="pa-0" style="display: flex;">
                                <v-subheader>Priorità</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.order_priority }} </div>
                            </v-col>
                            <v-col cols="12" class="pa-0" style="display: flex;">
                                <v-subheader>Colori</v-subheader>
                                <div style="margin: auto; margin-left: 0;">
                                    <v-chip v-for="(color, c) in model.color" small :key="c">{{ color }}</v-chip>
                                </div>
                            </v-col>
                            <v-col cols="8" class="pa-0" style="display: flex;">
                                <v-subheader>Cliente</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0;">{{ model.business_name }}
                                    <v-btn icon @click="$eventBusUtility.goTo($router, 'companies', model.company_id)">
                                        <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </div>
                            </v-col> 
                            <v-col cols="4" class="pa-0" style="display: flex;">
                                <v-subheader>Data di consegna</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ formatDate(model.delivery_date) }} </div>
                            </v-col> 
                            <v-col cols="8" class="pa-0" style="display: flex;">
                                <v-subheader>Ordine</v-subheader>
                                <div class="body-2 font-weight-medium cursor-pointer" style="margin: auto; margin-left: 0;">{{ model.sectional }} \ {{ model.number }}
                                    <v-btn icon @click="$eventBusUtility.goTo($router, 'saleorders', model.saleorder_id)">
                                        <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </div>
                            </v-col> 
                            <v-col cols="4" class="pa-0" style="display: flex;">
                                <v-subheader>Quantità evasa</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.dispatched_quantity }} di {{ model.quantity }}</div>
                            </v-col>
                            <v-col class="offset-xs pa-0" cols="12" style="display: flex;">
                                <v-subheader>Quantità già prodotta</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.lp_processed_quantity }}</div>
                            </v-col>
                            <v-subheader v-if="model.description">Descrizione</v-subheader>
                            <v-col class="px-3 pa-0 font-weight-medium" cols="12" style="display: flex;" v-if="model.description">
                                <div v-html="model.description"></div>
                            </v-col> 
                            <v-col class="px-3" cols="6" >
                                <v-autocomplete ref="createdialog"
                                    v-model="model.head"
                                    :items="heads"
                                    label="Testa*"
                                    hint="Seleziona la testa su cui mettere in produzione"
                                    item-text="text"
                                    item-value="head"
                                    :error-messages="errors.collect('Testa')"
                                    v-validate="'required'"
                                    :data-vv-name="'Testa'"
                                    dense
                                    outlined
                                ></v-autocomplete>
                            </v-col>
                            <v-col class="px-3" cols="6" >
                                <v-text-field
                                    v-model="model.quantity_to_process"
                                    type="number"
                                    label="Quantità*"
                                    :error-messages="errors.collect('Quantità')"
                                    v-validate="'required'"
                                    :data-vv-name="'Quantità'"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeDialogLoomProduct()">Annulla</v-btn>
                    <v-btn color="info" text @click="addLoomProduct()">Aggiungi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="editDialog"
            width="800"
            ref="editdialog">
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Modifica prodotto in produzione</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="pa-2" fluid>
                        <v-row class="ma-0">
                            <v-col cols="8" class="pa-0" style="display: flex;">
                                <v-subheader>Prodotto</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.name }}
                                    <v-btn icon @click="$eventBusUtility.goTo($router, 'products', model.product_id)">
                                        <v-icon>keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col cols="4" class="pa-0" style="display: flex;">
                                <v-subheader>Priorità</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.order_priority }} </div>
                            </v-col>
                            <v-col cols="12" class="pa-0" style="display: flex;">
                                <v-subheader>Colori</v-subheader>
                                <div style="margin: auto; margin-left: 0;">
                                    <v-chip v-for="(color, c) in model.color" small :key="c">{{ color }}</v-chip>
                                </div>
                            </v-col>
                            <v-col cols="8" class="pa-0" style="display: flex;">
                                <v-subheader>Cliente</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0;">{{ model.business_name }}
                                    <v-btn icon @click="$eventBusUtility.goTo($router, 'companies', model.company_id)">
                                        <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </div>
                            </v-col> 
                            <v-col cols="4" class="pa-0" style="display: flex;">
                                <v-subheader>Data di consegna</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ formatDate(model.delivery_date) }} </div>
                            </v-col> 
                            <v-col cols="8" class="pa-0" style="display: flex;">
                                <v-subheader>Ordine</v-subheader>
                                <div class="body-2 font-weight-medium cursor-pointer" style="margin: auto; margin-left: 0;">{{ model.sectional }} \ {{ model.number }}
                                    <v-btn icon @click="$eventBusUtility.goTo($router, 'saleorders', model.saleorder_id)">
                                        <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </div>
                            </v-col> 
                            <v-col cols="4" class="pa-0" style="display: flex;">
                                <v-subheader>Quantità evasa</v-subheader>
                                <div class="body-2 font-weight-medium" style="margin: auto; margin-left: 0; margin-right: 0;">{{ model.dispatched_quantity }} di {{ model.quantity }}</div>
                            </v-col>
                            <v-subheader v-if="model.description">Descrizione</v-subheader>
                            <v-col class="px-3" cols="12" style="display: flex;" v-if="model.description">
                                <div v-html="model.description"></div>
                            </v-col> 
                            <v-col class="px-3" cols="6" >
                                <v-autocomplete 
                                    v-model="model.status"
                                    v-if="fieldsset.loom_product_status"
                                    :items="fieldsset.loom_product_status.options"
                                    label="Stato"
                                    hint="Seleziona lo stato del prodotto in lavorazione"
                                    :error-messages="errors.collect('Stato')"
                                    v-validate="'required'"
                                    :data-vv-name="'Stato'"
                                    dense
                                    outlined
                                    >
                                    <template v-slot:item="{ index, item }">
                                        <v-list-item-content>
                                            <span class="pl-2 body-2">{{ item.text }}</span>
                                        </v-list-item-content>
                                        <v-list-item-action @click.stop>
                                            <v-icon :class="colorProductStatus(item.value)">fiber_manual_record</v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col class="px-3" cols="6" >
                                <v-text-field
                                    v-model="model.processed_quantity"
                                    type="number"
                                    label="Quantità lavorata"
                                    :error-messages="errors.collect('Quantità lavorata')"
					                v-validate="'required'"
					                :data-vv-name="'Quantità lavorata'"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeDialogLoomProduct()">Annulla</v-btn>
                    <v-btn color="info" :loading="saveLoomProduct" text @click="editLoomProduct()">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

    import Draggable from 'vuedraggable/dist/vuedraggable.common.js'
    import Vue from 'vue'
    import { mapGetters } from 'vuex'

    export default {
        name: "production-manager",
        components: {
            Draggable
        },

        props: {
            modelDef: String
        },

        data() {
            return {
                drawer: true,
                mini: false,
                drawerExpand: {},
                zones: {},
                fieldsset: [],
                products_to_process: [],
                products_in_process: [],
                currentLoom: {},
                dialog: false,
                editDialog: false,
                model: {},
                heads: [],
                search: '',
                searchInHeads: '',
                confirmDelete: false,
                productToDelete: null,
                isManager: false,
                productCategoriesSelected: null,
                debounceUnwatch: {},
                loomProductSaleorderItems: [],
                isLoading: false,
                saveLoomProduct: false,
            }
        },


        computed: {

            isProduction() {
                if(this.modelDef == 'production') {
                    return true 
                } else {
                    return false
                }
            },

            headNumber() {
                if(this.currentLoom.heads_number) {
                    return parseInt(this.currentLoom.heads_number) 
                } else {
                    return 0
                }
            },

            productsInProcess() {
                const search = this.search.toLowerCase().trim();
                if (!search) return this.products_to_process;

                return Object.assign(
                    {},
                    ...Object
                        .keys(this.products_to_process)
                        .filter(k => this.products_to_process[k].name.toLowerCase().indexOf(search) > -1 
                        || this.products_to_process[k].business_name.toLowerCase().indexOf(search) > -1
                        || this.products_to_process[k].quantity_to_process.toString().indexOf(search) > -1)
                        .map(k => ({ [k]: this.products_to_process[k] }))
                );
            },

            formatDate(date) {
                return (date) => {
                    return moment(date).format('L')
                }
            },

            colorProductStatus(loom_product_status) {
                return (loom_product_status) => {
                    switch(loom_product_status) {
                        case 'under_processing':
                        return 'teal--text'
                        case 'completed':
                        return 'green--text'
                        case 'mounted':
                        return 'indigo--text'
                        case 'added':
                        return 'orange--text'
                        default:
                        return 'grey'
                    }
                }
            },

            ...mapGetters(['status'])

        },

        watch: {
            status: {
                handler(newValue, oldValue) {
                    if(newValue) {
                        this.isManager = this.$store.getters.checkModelPermissions('productionmanager')
                    }
                }
            },

            productCategoriesSelected: {
                handler(newValue, oldValue) {
                    this.getProductsToProcess()
                }
            },

            searchInHeads: {
				handler() {

				}
			},
        },

        beforeRouteLeave(to, from, next) {
            this.pusherUnconnect()
            next()
        },

        mounted() {
            if(this.status) {
                this.pusherConnect()
            }
        },

        created() {
            // problema refresh
            this.isManager = this.$store.getters.checkModelPermissions('productionmanager')

            this.axios.get('production-info').then(response => {
                // get body data
                this.zones = response.data.info.zones
                this.fieldsset = response.data.info.fields
                this.$store.commit('endProgress')
                if(this.isManager) {
                    this.getProductsToProcess()
                }
                
                this.debounceUnwatch = this.$watch('searchInHeads', _.debounce(
                    this.filterInHeads,
                    700
                ))

                }, response => {
                    // error callback
            });
        },


        methods: {

            setLoom(loom) {
                this.currentLoom = loom
                this.heads = []
                for(let i = 1; i <= this.currentLoom.heads_number; i++) {
                    this.heads.push({'head': i, 'text': 'Testa ' + i})
                }
                this.getProductsInProcess()
            },

            openDialog(product_to_process) {
                Object.assign(this.model, product_to_process)
                this.model.loom_id  = this.currentLoom.id
                this.dialog = true
                this.errors.clear()
            },

            openEditDialog(product_in_process) {
                Object.assign(this.model, product_in_process)
                this.model.id  = product_in_process.id
                this.editDialog = true
                this.errors.clear()
            },

            closeDialogLoomProduct() {
                this.dialog = false
                this.saveLoomProduct = false
                this.editDialog = false
                this.model = {}
                this.errors.clear()
            },

            getProductsInProcess() {
                this.axios.post('productsinprocess',{'loom_id': this.currentLoom.id}).then(response => {
                    // get body data
                    this.products_in_process = response.data.data.products_in_process
                    for(let i = 1; i <= this.headNumber; i++) {
                        if(typeof this.products_in_process[i] === 'undefined'){
                            Vue.set(this.products_in_process, i, [])
                        }
                    }
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                });
            },

            getProductsToProcess() {
                this.axios.post('productstoprocess',{'category_id': this.productCategoriesSelected}).then(response => {
                    // get body data
                    this.products_to_process = response.data.data.products_to_process
                    this.$store.commit('endProgress')

                }, response => {
                        // error callback
                });
            },

            addLoomProduct() {

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    let data = {
                        'loom_id': this.model.loom_id,
                        'productsaleorder_id': this.model.productsaleorder_id,
                        'head': this.model.head,
                        'quantity_to_process': parseFloat(this.model.quantity_to_process)
                    }                     
                    this.axios.post('loomproductsaleorders', data).then(response => {
                        // get body data
                        this.closeDialogLoomProduct()

                    }, response => {
                                // error callback
                    })
                }).catch(() => {
                    
                })
            },

            editLoomProduct() {
                this.saveLoomProduct = true
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    let data = {
                        'status': this.model.status,
                        'processed_quantity': this.model.processed_quantity
                    }                    
                    this.axios.put('loomproductsaleorders/' + this.model.id, data).then(response => {
                        // get body data
                        this.closeDialogLoomProduct()
                    }, response => {
                                // error callback
                    });
                }).catch(() => {
                    
                })
            },

            onDrag(event, entity) {

                let data = {
                    id: null,
                    prev_id: null,
                    type: 'order',
                    loom_id: this.currentLoom.id
                }

                data.id = parseInt(event.item.id)

                // take all product in current head
                let children = event.to.childNodes
                // search index of product and after take precedent id
                let index = _.findIndex(children, (value) => {
                    return parseInt(value.id) === data.id
                })
                if (index > 0) {
                    data.prev_id = parseInt(children[index - 1].id)
                } // else is the first
                data.n_head = parseInt(event.to.offsetParent.id)
                
                this.axios.post('loomproductsaleordersorder/', data).then(response => {

                }, response => {
                    // error callback
                });
            },

            startDelete(product) {
                this.confirmDelete = true
                this.productToDelete = product.id
            },

            deleteLoomProduct() {
                this.axios.post('loomproductsaleorders/delete', {ids: [this.productToDelete]}).then(response => {
                    this.productToDelete = null
                    this.getProductsInProcess()

                    let snackmessage = ''
                    let snackcolor = ''
                    if(response.data.status == 'message' || response.data.message) {
                        snackmessage = response.data.message
                        snackcolor = response.data.type
                    } else{
                        snackmessage = 'Elementi eliminati con successo.'
                        snackcolor = 'success'
                    }
                    this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
                
                }, response => {
                    // error callback
                });
            },

            filterInHeads() {
                this.isLoading = true
                this.axios.post('loomproductsaleorders-filters', {filter: this.searchInHeads}).then(response => {
                    this.loomProductSaleorderItems = response.data.data
                    this.isLoading = false
                }, response => {
                    // error callback
                });            
            },

            pusherConnect() {
                if(this.$echo) {
                    this.$echo.private('refreshProduction.' + this.$store.getters.uuid)
                    .listen('.SaleOrderSaved', (e) => {
                        this.getProductsToProcess()
                    })
                    .listen('.LoomProductSaleorderSaved', (e) => {
                        if(e.loom_id === this.currentLoom.id) {
                            this.getProductsInProcess()
                        }
                        if(this.isManager) {
                            this.getProductsToProcess()
                        }
                    })
                    // .on('subscription_succeeded', () => {
                    //     // console.log('success refreshProduction');
                    // })
                    // .on('subscription_error', () => {
                    //     // console.log('error refreshProduction');
                    // })
                }
            },

            pusherUnconnect() {
                if(this.$echo) {
                    this.$echo.leave('refreshProduction.' + this.$store.getters.uuid)
                }
            }
        },
    }
</script>

<style>
    .container-production {
        box-sizing: border-box;
        display: flex;
        position: absolute;
        top: 0;
        right: 0px;
        bottom: 0;
        left: 0px;
        height: 100%;
        overflow-y: hidden;
        overflow-x: auto;
    }

    .navigation-drawer-looms {
        height: calc(100% - 65px) !important;
        border-right: 2px solid #f4f4f4;
        border-left: 2px solid #f4f4f4;
        top: 65px !important;
    }

    .heads-container {
        display: flex; 
        position: absolute; 
        left: 200px; 
        /*right: 200px;*/
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
        height: calc(100% - 65px);
        overflow-x: auto;
        overflow-y: hidden;
    }

    .head {
        width: 220px;
        min-width: 180px;
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
    }

    .head-header {
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
        place-content: center space-between;
        align-items: center;
        flex: 1 1 1e-09px;
        max-height: 56px;
        z-index: 2;
    }


    .head-item {
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        position: relative;
        min-height: 0;
        overflow: hidden;
        overflow-y: auto;
        padding: 0;
    }

    .product-to-process {
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        position: relative;
        min-height: 0;
        overflow: hidden;
        overflow-y: auto;
        padding: 0;
        top: 88px;
    }

    .product-to-process-item:hover {
        opacity: 0.4;
    }

    .product-in-process-item:hover {
        opacity: 0.4;
    }

    .product-to-process .v-chip {
        font-size: 10px;
        margin: 0px;
    }

    .product-in-process .v-chip {
        font-size: 10px;
        margin: 0px;
    }

    .product-to-process .v-chip .v-chip__content {
        padding: 0 4px;
    }

    .product-in-process .v-chip .v-chip__content {
        padding: 0 4px;
    }

    .main-toolbar > .v-toolbar__content {
        height: 64px !important;
        padding-left: 0 !important;
    }

    .ghost {
        background: #eeeeee;
        opacity: 0;
    }

    .chosen {
        background: #eeeeee;
        opacity: 1;
    }

    .zones-list .v-list-item__title {
        font-size: 12px !important;
        padding: 0px;
    }

    .zones-list .v-list-item {
        padding-left: 8px;
    }

    .zones-list .v-list-item__icon {
        margin-right: 0px !important;
    }

    .zones-list .v-list__group .v-list-item__title {
        padding-left: 8px !important;
    }

    .zones-list .v-list__group__header .v-list__group__header__prepend-icon {
        min-width: 40px;
        padding-left: 8px;
        padding-right: 8px;
    }

    .small-icon .v-icon {
        font-size: 22px
    }

    .main-toolbar .v-toolbar__content {
        padding-right: 16px !important
    }
</style>
